import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FooterDetails from "./FooterDetails";
import FooterLinks from "./FooterLinks";
const Footer = ({ footerSettings }) => {
    return (_jsx("footer", { className: "footer", "data-ktc-search-exclude": true, children: _jsxs("div", { className: "footer__container container", children: [_jsx(FooterLinks, { links: footerSettings.footerLinks }), _jsx(FooterDetails, { details: footerSettings })] }) }));
};
export default Footer;
